import { Route } from '@angular/router';
import { LoginGuard, PermissionGuard } from '@simac/ui';

export const AssetToolsRoute: Route = {
  path: 'tools',
  children: [
    {
      path: '',
      loadComponent: () => import('./pages/asset-tools.component').then((m) => m.AssetToolsComponent),
    },
  ],
  canActivate: [LoginGuard, PermissionGuard],
};
